<div class="list-page kapea" style="max-width: 1200px">
  <div class="ylaosan-kontrollit">
    <button type="button" class="etsi-nappi" (click)="avaaHaku()" aria-haspopup="dialog" [attr.aria-label]="'asiakkaat.haku.avaa-haku' | translate | async">
      <mat-icon>search</mat-icon>
      <span>{{ 'asiakkaat.etsi-asiakkaita' | translate | async }}</span>
    </button>
    <div class="lisaa-nappula-container">
      <button mat-button (click)="lisaa()" type="button" class="primarybutton mat-elevation-z4"><mat-icon style="padding-right: 6px">add</mat-icon>{{ 'asiakkaat.lisaa' | translate | async }}</button>
    </div>
  </div>

  <div style="margin: 3em">
    {{ 'asiakkaat.vihje' | translate | async }}
  </div>

  <div style="position: relative">
    <mat-table matSort [dataSource]="naytettavatAsiakkaatObservable | async" [matSortDisableClear]="true" style="min-height: 94px">
      <ng-container matColumnDef="nimi">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'asiakkaat.nimi' | translate | async }} </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-icon class="tyyppi-ikoni">{{ row.asiakastyyppi === 'h' ? 'person' : 'business' }}</mat-icon>
          {{ row.nimi }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="ytunnus">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 90px"> {{ 'asiakkaat.ytunnus' | translate | async }} </mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 90px"> {{ row.ytunnus ? row.ytunnus : '&nbsp;' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="postitoimipaikka">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 200px"> {{ 'asiakkaat.paikkakunta' | translate | async }} </mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 200px">
          <span>{{ row.postitmp }}</span>
          @if (row.maa && row.maa !== 'FIN') {
            <span>{{ row.postitmp ? ', ' : '' }}{{ row.maa | lmaa | async }}</span>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="myynninLaji">
        <mat-header-cell *matHeaderCellDef style="max-width: 220px"> {{ 'asiakkaat.myynnin-laji' | translate | async }} </mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 220px"> {{ row.laskunTyyppi ? ('myynnin-laji.' + row.laskunTyyppi | translate | async) : '–' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="toimitus">
        <mat-header-cell *matHeaderCellDef style="max-width: 260px"> {{ 'asiakkaat.toimitus' | translate | async }} </mat-header-cell>
        <mat-cell *matCellDef="let row" class="toimitus" style="max-width: 260px"> {{ row.toimitusteksti }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="maksuehto">
        <mat-header-cell *matHeaderCellDef class="maksuehto" style="max-width: 120px"> {{ 'asiakkaat.maksuehto' | translate | async }} </mat-header-cell>
        <mat-cell *matCellDef="let row" class="maksuehto" style="max-width: 120px">
          @if (row.maksuaikaa) {
            {{ row.maksuaikaa }} {{ 'lasku.pv-netto' | translate | async }}
          } @else {
            –
          }
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="propertiesToDisplay"></mat-header-row>
      <mat-row (click)="muokkaa(row)" *matRowDef="let row; columns: propertiesToDisplay"></mat-row>
    </mat-table>
    @if (naytaEiYhtaanObservable | async) {
      <div class="table-ladataan" style="position: absolute; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
        <div style="width: 100%; padding-top: 40px; text-align: center">
          {{ 'asiakkaat.rekisteri-tyhja' | translate | async }}
          <div>{{ 'asiakkaat.rekisteri-tyhja-vihje' | translate | async }}</div>
        </div>
      </div>
    }
    <div lemon-loading [show]="lataaObservable | async"></div>
  </div>

  <mat-paginator #paginator [length]="dataSource.rivienMaaraObservable | async" [pageSize]="dataSource?.getPage().pageSize" [pageIndex]="dataSource?.getPage().pageIndex" [pageSizeOptions]="[20, 50, 200]"> </mat-paginator>
</div>
<app-asiakasrekisteri-haku [avoinna]="hakuAvoinna" (suljettu)="suljeHaku()"></app-asiakasrekisteri-haku>
